import { render, staticRenderFns } from "./powerdata.vue?vue&type=template&id=1daa3e62&scoped=true&"
import script from "./powerdata.vue?vue&type=script&lang=js&"
export * from "./powerdata.vue?vue&type=script&lang=js&"
import style0 from "./powerdata.vue?vue&type=style&index=0&id=1daa3e62&lang=less&rel=stylesheet%2Fless&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1daa3e62",
  null
  
)

export default component.exports